import React from 'react';
import styles from './shorts-pill.module.css';

const CopyIcon = () => (
  <svg width="14" height="16" viewBox="82 7 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M85.5417 19.7502V7.0835H95.8333V19.7502H85.5417ZM82.375 22.9168V10.2502H83.9583V21.3335H92.6667V22.9168H82.375Z"
      fill="white"
    />
  </svg>
);

interface ShortsPillProps {
  text: string;
}

const ShortsPill = ({ text }: ShortsPillProps) => (
  <div className={styles.pill}>
    <span className={styles.text}>{text}</span>
    <CopyIcon />
  </div>
);

export default ShortsPill;
